import type { CanonicalProduct, ProductAdapter } from './types'
import { errorHandler } from './utils'

const adapters = new Map<string, ProductAdapter>()

/**
 * Registers an application's product adapter — one per application, mapping
 * its own domain model into the canonical product shape (FC-183 §6, A7).
 * Registered once at init; a second registration for the same application
 * replaces the first.
 */
export const registerProductAdapter = (
  applicationId: string,
  adapter: ProductAdapter,
): void => {
  adapters.set(applicationId, adapter)
}

/**
 * Resolves a product through the owning application's adapter.
 * Returns undefined — never throws — when no adapter is registered or the
 * adapter fails: a product-resolution failure must not break the event.
 */
export const resolveProduct = (
  applicationId: string,
  input: unknown,
): CanonicalProduct | undefined => {
  const adapter = adapters.get(applicationId)
  if (!adapter) {
    return undefined
  }
  try {
    return adapter(input)
  } catch (error) {
    errorHandler(error as Error)
    return undefined
  }
}
